import {
    IGestaoProdutosVinculados,
    IProdutoEquipe,
} from "../../../Interfaces/Vendas/GestaoProdutoVinculados/GestaoProdutosVinculadosInterface";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function ListarProdutosVinculadosService(idEquipeVendas: number) {
    return Service(
        Axios.get<Array<IGestaoProdutosVinculados>>(
            `/vendas/equipevendasproduto/listarprodutosporequipevendas?idEquipeVendas=${idEquipeVendas}`
        )
    );
}

export async function ListarProdutosDesvinculadosService(
    idEquipeVendas: number
) {
    return Service(
        Axios.get<Array<IGestaoProdutosVinculados>>(
            `/vendas/equipevendasproduto/listarprodutosdesvinculadosporequipevendas?idEquipeVendas=${idEquipeVendas}`
        )
    );
}
export async function InsereEquipeVendasProdutoService(
    requestBody: IGestaoProdutosVinculados
) {
    return Service(
        Axios.post(
            `/vendas/equipevendasproduto/insereequipevendasproduto`,
            requestBody
        )
    );
}
export async function DeletaEquipeVendasProdutoService(
    idEquipeVendasProduto: number
) {
    return Service(
        Axios.delete(
            `/vendas/equipevendasproduto/deletaequipevendasproduto?idEquipeVendasProduto=${idEquipeVendasProduto}`
        )
    );
}
export async function DeletarProdutoEquipeVendaService(
    requestBody: IProdutoEquipe
) {
    return Service(
        Axios.put(
            `/vendas/equipevendas/desvincularprodutoequipevenda`,
            requestBody,
            { responseType: "json" }
        )
    );
}
export async function VincularProdutoEquipeVendaService(
    requestBody: IProdutoEquipe
) {
    return Service(
        Axios.post(
            `/vendas/equipevendas/vincularprodutoequipevenda`,
            requestBody
        )
    );
}
